var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { connect } from '../../store/connect';
import { Button } from "../Form";
import get from "lodash/get";
import { BookingFormPopup } from "../BookingFormPopup/BookingFormPopup";
import { getInitialData } from "../../store/actions/response.actions";
import { ADD_TO_CART_BUTTON } from "../../classConstants";
import { useTranslation } from "react-i18next";
import { API_METHODS_ENUM } from "../../httpService";
import { LoaderState } from "../../store/actions/loader.actions";
import { useConfig } from "../../AppContext";
import { getIntegrationURL } from "../../store/stateGetter";
import { AppBootstrapComponent } from "../AppBootstrapComponent";
import { useCampaignName } from "../useCampaignName";
var addToCartFactory = function () {
    var AddToCartComponent = function (props) {
        var t = useTranslation().t;
        var _a = useState(props.showPopup), showPopup = _a[0], setShowPopup = _a[1];
        var showAddToCartButton = useConfig("addToCart.showAddToCartButton", true)[0];
        var propsRef = React.useRef(props || {}).current;
        var togglePopup = function (showPopup) {
            return function () {
                setShowPopup(showPopup);
                if (!showPopup && props.onModalClose)
                    setTimeout(function () { return props.onModalClose(); });
            };
        };
        useCampaignName(propsRef.searchParams);
        if (props.isLoading)
            return null;
        return (React.createElement(React.Fragment, null,
            showAddToCartButton && React.createElement(Button, { className: ADD_TO_CART_BUTTON, onClick: togglePopup(true) }, t("cart.add_to_cart")),
            showPopup && React.createElement(BookingFormPopup, { integrationUrl: props.integrationUrl, hasCart: props.hasCart, showTimespanSearchAndSelect: true, buttonsWithIcon: true, onClose: togglePopup(false), timespanId: props.timespanId })));
    };
    var mapStateToProps = function (state) {
        var _a;
        return {
            cartItems: get(state, "cartReducer.cart_items", []),
            initialData: (_a = getInitialData(state.responseReducer)) === null || _a === void 0 ? void 0 : _a.response,
            integrationUrl: getIntegrationURL(state),
            loaderState: state.loaderReducer
        };
    };
    var mergeProps = function (_a, dispatch, props) {
        var cartItems = _a.cartItems, integrationUrl = _a.integrationUrl, loaderState = _a.loaderState;
        return {
            cartItemsCount: cartItems.length,
            integrationUrl: integrationUrl,
            attributes: props.attributes,
            timespanId: +get(props.attributes, "timespanid") || null,
            showPopup: get(props, "showPopup") || false,
            onModalClose: get(props, "onModalClose") || null,
            isLoading: new LoaderState(loaderState, { keys: [API_METHODS_ENUM.GET_INITIAL_ENTITIES] }).isLoading()
        };
    };
    var WrappedAddToCart = function (props) { return (React.createElement(AppBootstrapComponent, __assign({}, props, { Component: AddToCartComponent }))); };
    return connect(mapStateToProps, null, mergeProps)(WrappedAddToCart);
};
export var AddToCart = addToCartFactory();
